/**
 * Created by bestxie on 2017/12/14.
 */
(function (doc, win) {
    let UA = navigator.userAgent,
      isAndroid = /android|adr/gi.test(UA),
      isIos = /iphone|ipod|ipad/gi.test(UA) && !isAndroid, // 据说某些国产机的UA会同时包含 android iphone 字符
      isMobile = isAndroid || isIos; // 粗略的判断
      WIDTH = isMobile ? 750 : 1920;
    var docEl = doc.documentElement, resizeEvt = ('orientationchange' in window ? 'orientationchange' : 'resize'),
      recalc = function () {
        var clientWidth = docEl.getBoundingClientRect().width;
        // clientWidth = clientWidth > 750 ? 750 : clientWidth;
        if (!clientWidth) return;
        docEl.style.fontSize = (100 * (clientWidth / WIDTH)) + 'px';
      };
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener('DOMContentLoaded', recalc, false);
  })(document, window);



// WEBPACK FOOTER //
// ./src/assets/js/rem.js